import { createFileRoute } from "@tanstack/react-router";
import { LocaleContactRich } from "@/components/LocaleContactRich";
import { LOCALE_CONTACT } from "@/data/locale-pages-content";
import { LOCALE_PAGE_DEEP } from "@/data/locale-page-deep";
import { buildLocalePageHead } from "@/lib/locale-static-head";

export const Route = createFileRoute("/zh/contact")({
  loader: () => ({ h: buildLocalePageHead("contact", "zh") }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => (
    <LocaleContactRich content={LOCALE_CONTACT.zh} deep={LOCALE_PAGE_DEEP.zh.contact} />
  ),
});
